
import {
	ifAuthenticated,
	ifAuthenticatedOnline,
	ifHrEmployee,
	canAccess,
	AppTabs,
	Edit,
	Show,
	Create,
	Crud,
	trans
} from '@/router/index'

import HrEmployee from '@/components/modules/hr/HrEmployee'
const HrMe = () => import(/* webpackChunkName: "hr-me" */ '@/components/modules/hr/HrMe')
import HrEmployeeTabs from '@/components/modules/hr/HrEmployeeTabs'
import HrEmployeeAccount from '@/components/modules/hr/HrEmployeeAccount'
import HrEmployeeContracts from '@/components/modules/hr/HrEmployeeContracts'
import HrEmployeeShift from '@/components/modules/hr/HrEmployeeShift'
import HrEmployeeAttendanceConfig from '@/components/modules/hr/HrEmployeeAttendanceConfig'
import HrEmployeeAudit from '@/components/modules/hr/HrEmployeeAudit'
const HrEmployeeTfr = () => import(/* webpackChunkName: "hr-tfr" */ '@/components/modules/hr/HrEmployeeTfr')
// Lazy-loaded route chunks (file > 300 LOC): caricati on-demand per ridurre bundle iniziale.
const HrCartellino = () => import(/* webpackChunkName: "hr-cartellino" */ '@/components/modules/hr/HrCartellino')
import HrClockWidget from '@/components/modules/hr/HrClockWidget'
const HrAbsences = () => import(/* webpackChunkName: "hr-absences" */ '@/components/modules/hr/HrAbsences')
import HrTeamCalendar from '@/components/modules/hr/HrTeamCalendar'
import HrLeaveBalancePanel from '@/components/modules/hr/HrLeaveBalancePanel'
import HrApprovalsInbox from '@/components/modules/hr/HrApprovalsInbox'
const HrTimelineMerge = () => import(/* webpackChunkName: "hr-timeline" */ '@/components/modules/hr/HrTimelineMerge')
const HrPayslips = () => import(/* webpackChunkName: "hr-payslips" */ '@/components/modules/hr/HrPayslips')
import HrTicketTimesheets from '@/components/modules/hr/HrTicketTimesheets'
import HrReports from '@/components/modules/hr/HrReports'
import HrExpenseReports from '@/components/modules/hr/HrExpenseReports'
const HrExpenses = () => import(/* webpackChunkName: "hr-expenses" */ '@/components/modules/hr/HrExpenses')
import HrTrainings from '@/components/modules/hr/HrTrainings'
import HrPerformanceReviews from '@/components/modules/hr/HrPerformanceReviews'
import HrOnboardings from '@/components/modules/hr/HrOnboardings'
import HrShiftTemplateEdit from '@/components/modules/hr/HrShiftTemplateEdit'
import HrClockDeviceEdit from '@/components/modules/hr/HrClockDeviceEdit'
const HrOrgChart = () => import(/* webpackChunkName: "hr-orgchart" */ '@/components/modules/hr/HrOrgChart')
const HrImports = () => import(/* webpackChunkName: "hr-imports" */ '@/components/modules/hr/HrImports')

export const hr = [
	// Contratti
	{
		path: '/hrcontracts',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrcontracts/', text: 'Contratti' }] },
		children: [
			{
				path: '/hrcontracts/',
				name: 'hrcontracts-index',
				meta: { title: 'Contratti' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrcontract', next) },
				component: Crud,
				props: { modelDef: 'hrcontracts', actionIcon: 'mdi-file-sign', title: 'Contratti', styleClass: 'mb-offset' }
			},
		],
	},
	{ path: '/hrcontracts/create', name: 'hrcontracts-create', beforeEnter: ifAuthenticatedOnline, component: Create, props: (route) => ({ modelDef: 'hrcontracts', defaultInput: route.params.defaultInput, redirect: route.params.redirect || { modelDef: 'hrcontracts-index' } }) },
	{ path: '/hrcontracts/:id/edit', name: 'hrcontracts-edit', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hrcontracts', id: parseInt(route.params.id), redirect: route.params.redirect || { modelDef: 'hrcontracts-index' } }) },
	{ path: '/hrcontracts/:id', name: 'hrcontracts-show', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hrcontracts', id: parseInt(route.params.id) }) },

	// Onboarding templates (CRUD per pagina Impostazioni HR)
	{ path: '/hronboardingtemplates/create', name: 'hronboardingtemplates-create', beforeEnter: ifAuthenticatedOnline, component: Create, props: (route) => ({ modelDef: 'hronboardingtemplates', defaultInput: route.params.defaultInput, redirect: route.params.redirect || { modelDef: 'hrsettings-onboardingtemplates' } }) },
	{ path: '/hronboardingtemplates/:id/edit', name: 'hronboardingtemplates-edit', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hronboardingtemplates', id: parseInt(route.params.id), redirect: route.params.redirect || { modelDef: 'hrsettings-onboardingtemplates' } }) },
	{ path: '/hronboardingtemplates/:id', name: 'hronboardingtemplates-show', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hronboardingtemplates', id: parseInt(route.params.id) }) },

	// Reparti
	{
		path: '/hrdepartments',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrdepartments/', text: 'Reparti' }] },
		children: [
			{
				path: '/hrdepartments/',
				name: 'hrdepartments-index',
				meta: { title: 'Reparti' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrdepartment', next) },
				component: Crud,
				props: { modelDef: 'hrdepartments', actionIcon: 'mdi-domain', title: 'Reparti', styleClass: 'mb-offset' }
			},
		],
	},
	{ path: '/hrdepartments/create', name: 'hrdepartments-create', beforeEnter: ifAuthenticatedOnline, component: Create, props: (route) => ({ modelDef: 'hrdepartments', defaultInput: route.params.defaultInput, redirect: route.params.redirect || { modelDef: 'hrdepartments-index' } }) },
	{ path: '/hrdepartments/:id/edit', name: 'hrdepartments-edit', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hrdepartments', id: parseInt(route.params.id), redirect: route.params.redirect || { modelDef: 'hrdepartments-index' } }) },
	{ path: '/hrdepartments/:id', name: 'hrdepartments-show', beforeEnter: ifAuthenticatedOnline, component: Show, props: (route) => ({ modelDef: 'hrdepartments', id: parseInt(route.params.id) }) },

	// Mansioni
	{
		path: '/hrjobtitles',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrjobtitles/', text: 'Mansioni' }] },
		children: [
			{
				path: '/hrjobtitles/',
				name: 'hrjobtitles-index',
				meta: { title: 'Mansioni' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrjobtitle', next) },
				component: Crud,
				props: { modelDef: 'hrjobtitles', actionIcon: 'mdi-briefcase-outline', title: 'Mansioni', styleClass: 'mb-offset' }
			},
		],
	},
	{ path: '/hrjobtitles/create', name: 'hrjobtitles-create', beforeEnter: ifAuthenticatedOnline, component: Create, props: (route) => ({ modelDef: 'hrjobtitles', defaultInput: route.params.defaultInput, redirect: route.params.redirect || { modelDef: 'hrjobtitles-index' } }) },
	{ path: '/hrjobtitles/:id/edit', name: 'hrjobtitles-edit', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hrjobtitles', id: parseInt(route.params.id), redirect: route.params.redirect || { modelDef: 'hrjobtitles-index' } }) },
	{ path: '/hrjobtitles/:id', name: 'hrjobtitles-show', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hrjobtitles', id: parseInt(route.params.id) }) },

	// Competenze
	{
		path: '/hrskills',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrskills/', text: 'Competenze' }] },
		children: [
			{
				path: '/hrskills/',
				name: 'hrskills-index',
				meta: { title: 'Competenze' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrskill', next) },
				component: Crud,
				props: { modelDef: 'hrskills', actionIcon: 'mdi-star-circle-outline', title: 'Competenze', styleClass: 'mb-offset' }
			},
		],
	},
	{ path: '/hrskills/create', name: 'hrskills-create', beforeEnter: ifAuthenticatedOnline, component: Create, props: (route) => ({ modelDef: 'hrskills', defaultInput: route.params.defaultInput, redirect: route.params.redirect || { modelDef: 'hrskills-index' } }) },
	{ path: '/hrskills/:id/edit', name: 'hrskills-edit', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hrskills', id: parseInt(route.params.id), redirect: route.params.redirect || { modelDef: 'hrskills-index' } }) },
	{ path: '/hrskills/:id', name: 'hrskills-show', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hrskills', id: parseInt(route.params.id) }) },

	// Dipendenti
	{
		path: '/hremployees',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{ to: '/hremployees/', text: 'Dipendenti' },
			],
		},
		children: [
			{
				path: '/hremployees/',
				name: 'hremployees-index',
				meta: { title: 'Dipendenti' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hremployee', next) },
				component: Crud,
				props: {
					modelDef: 'hremployees',
					actionIcon: 'mdi-account-tie',
					title: 'Dipendenti',
					styleClass: 'mb-offset'
				}
			},
		],
	},
	{ path: '/hremployees/create', name: 'hremployees-create', beforeEnter: ifAuthenticatedOnline, component: Create, props: (route) => ({ modelDef: 'hremployees', defaultInput: route.params.defaultInput ? route.params.defaultInput : null, redirect: route.params.redirect }) },
	{ path: '/hremployees/:id/edit', name: 'hremployees-edit', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hremployees', id: parseInt(route.params.id) }) },
	{
		path: '/hremployees/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: HrEmployeeTabs,
		props: (route) => ({ id: parseInt(route.params.id) }),
		children: [
			{
				path: '',
				name: 'hremployees-show',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hremployee', next) },
				component: HrEmployee,
				meta: { title: 'Dipendente' },
				props: (route) => ({ id: parseInt(route.params.id) }),
			},
			{
				path: 'account',
				name: 'hremployees-account',
				beforeEnter: ifAuthenticatedOnline,
				component: HrEmployeeAccount,
				meta: { title: 'Account utente' },
				props: (route) => ({ id: parseInt(route.params.id) }),
			},
			{
				path: 'contracts',
				name: 'hremployees-contracts',
				beforeEnter: ifAuthenticatedOnline,
				component: HrEmployeeContracts,
				meta: { title: 'Contratti' },
				props: (route) => ({ id: parseInt(route.params.id) }),
			},
			{
				path: 'shift',
				name: 'hremployees-shift',
				beforeEnter: ifAuthenticatedOnline,
				component: HrEmployeeShift,
				meta: { title: 'Turno' },
				props: (route) => ({ id: parseInt(route.params.id) }),
			},
			{
				path: 'attendance-config',
				name: 'hremployees-attendance-config',
				beforeEnter: ifAuthenticatedOnline,
				component: HrEmployeeAttendanceConfig,
				meta: { title: 'Configurazione timbratura' },
				props: (route) => ({ id: parseInt(route.params.id) }),
			},
			{
				path: 'audit',
				name: 'hremployees-audit',
				beforeEnter: ifAuthenticatedOnline,
				component: HrEmployeeAudit,
				meta: { title: 'Cronologia modifiche' },
				props: (route) => ({ id: parseInt(route.params.id) }),
			},
			{
				path: 'tfr',
				name: 'hremployees-tfr',
				beforeEnter: ifAuthenticatedOnline,
				component: HrEmployeeTfr,
				meta: { title: 'Calcolo TFR' },
				props: (route) => ({ id: parseInt(route.params.id) }),
			},
		]
	},

	// Luoghi di Lavoro
	{
		path: '/hrworkplaces',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrworkplaces/', text: 'Luoghi di Lavoro' }] },
		children: [
			{
				path: '/hrworkplaces/',
				name: 'hrworkplaces-index',
				meta: { title: 'Luoghi di Lavoro' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrworkplace', next) },
				component: Crud,
				props: { modelDef: 'hrworkplaces', actionIcon: 'mdi-map-marker', title: 'Luoghi di Lavoro', styleClass: 'mb-offset' }
			},
		],
	},
	{ path: '/hrworkplaces/create', name: 'hrworkplaces-create', beforeEnter: ifAuthenticatedOnline, component: Create, props: (route) => ({ modelDef: 'hrworkplaces', defaultInput: route.params.defaultInput ? route.params.defaultInput : null, redirect: route.params.redirect }) },
	{ path: '/hrworkplaces/:id/edit', name: 'hrworkplaces-edit', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hrworkplaces', id: parseInt(route.params.id) }) },
	{
		path: '/hrworkplaces/:id',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '', text: 'Luogo di Lavoro' }] },
		children: [
			{
				path: '/hrworkplaces/:id',
				name: 'hrworkplaces-show',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrworkplace', next) },
				component: Show,
				meta: { title: 'Luogo di Lavoro' },
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'hrworkplaces',
					modelClass: 'hrworkplace',
					activities: true,
					fileuploader: true,
				}),
			},
		],
	},

	// Dispositivi Timbratura
	{
		path: '/hrclockdevices',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrclockdevices/', text: 'Dispositivi Timbratura' }] },
		children: [
			{
				path: '/hrclockdevices/',
				name: 'hrclockdevices-index',
				meta: { title: 'Dispositivi Timbratura' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrclockdevice', next) },
				component: Crud,
				props: { modelDef: 'hrclockdevices', actionIcon: 'mdi-qrcode', title: 'Dispositivi Timbratura', styleClass: 'mb-offset' }
			},
		],
	},
	{ path: '/hrclockdevices/create', name: 'hrclockdevices-create', beforeEnter: ifAuthenticatedOnline, component: Create, props: (route) => ({ modelDef: 'hrclockdevices', defaultInput: route.params.defaultInput ? route.params.defaultInput : null, redirect: route.params.redirect }) },
	{ path: '/hrclockdevices/:id/edit', name: 'hrclockdevices-edit', beforeEnter: ifAuthenticatedOnline, component: HrClockDeviceEdit, props: (route) => ({ id: parseInt(route.params.id) }) },
	{ path: '/hrclockdevices/:id', name: 'hrclockdevices-show', beforeEnter: ifAuthenticatedOnline, component: HrClockDeviceEdit, props: (route) => ({ id: parseInt(route.params.id) }) },

	// Deep-link da QR/NFC: apre il widget timbratura precompilato col codice device
	{ path: '/timbra/:code', name: 'hrclock-deeplink', beforeEnter: ifAuthenticated, component: HrClockWidget, props: (route) => ({ deviceCode: route.params.code }) },

	// Organigramma
	{
		path: '/hrorgchart',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrorgchart/', text: 'Organigramma' }] },
		children: [
			{ path: '/hrorgchart/', name: 'hrorgchart-index', meta: { title: 'Organigramma' }, beforeEnter: (to, from, next) => canAccess('permission', 'hrorgchart', next), component: HrOrgChart },
		],
	},

	// Turni
	{
		path: '/hrshifttemplates',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrshifttemplates/', text: 'Turni' }] },
		children: [
			{
				path: '/hrshifttemplates/',
				name: 'hrshifttemplates-index',
				meta: { title: 'Turni' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrshifttemplate', next) },
				component: Crud,
				props: { modelDef: 'hrshifttemplates', actionIcon: 'mdi-calendar-clock', title: 'Turni', styleClass: 'mb-offset' }
			},
		],
	},
	{ path: '/hrshifttemplates/create', name: 'hrshifttemplates-create', beforeEnter: ifAuthenticatedOnline, component: HrShiftTemplateEdit, props: () => ({ id: null }) },
	{ path: '/hrshifttemplates/:id/edit', name: 'hrshifttemplates-edit', beforeEnter: ifAuthenticatedOnline, component: HrShiftTemplateEdit, props: (route) => ({ id: parseInt(route.params.id) }) },
	{ path: '/hrshifttemplates/:id', name: 'hrshifttemplates-show', beforeEnter: ifAuthenticatedOnline, component: HrShiftTemplateEdit, props: (route) => ({ id: parseInt(route.params.id) }) },

	// Timbrature
	{
		path: '/hrclocks',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{ to: '/hrclocks/', text: 'Storico Timbrature' },
				{ to: '/hrclocks/widget', text: 'Timbra' },
			],
		},
		children: [
			{
				path: '/hrclocks/',
				name: 'hrclocks-index',
				meta: { title: 'Timbrature' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrclock', next) },
				component: Crud,
				props: { modelDef: 'hrclocks', actionIcon: 'mdi-fingerprint', title: 'Timbrature', styleClass: 'mb-offset' }
			},
			{
				path: '/hrclocks/widget',
				name: 'hrclocks-widget',
				meta: { title: 'Timbra' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrclock', next) },
				component: HrClockWidget,
			},
		],
	},

	// Cartellino
	{
		path: '/hrworkingdays',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrworkingdays/', text: 'Cartellino' }] },
		children: [
			{
				path: '/hrworkingdays/',
				name: 'hrworkingdays-index',
				meta: { title: 'Cartellino' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrworkingday', next) },
				component: HrCartellino,
			},
		],
	},

	// Note Spese (singole, senza report mensile)
	{
		path: '/hrexpenses',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrexpenses/', text: 'Note Spese' }] },
		children: [
			{
				path: '/hrexpenses/',
				name: 'hrexpenses-index',
				meta: { title: 'Note Spese' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrexpense', next) },
				component: HrExpenses,
			},
		],
	},
	// Report Spese raggruppati (sezione secondaria, non-menu)
	{
		path: '/hrexpensereports',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrexpensereports/', text: 'Report Spese' }] },
		children: [
			{
				path: '/hrexpensereports/',
				name: 'hrexpensereports-index',
				meta: { title: 'Report Spese' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrexpensereport', next) },
				component: HrExpenseReports,
			},
		],
	},

	// Formazione
	{
		path: '/hrtrainings',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrtrainings/', text: 'Formazione' }] },
		children: [
			{
				path: '/hrtrainings/',
				name: 'hrtrainings-index',
				meta: { title: 'Formazione' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrtraining', next) },
				component: HrTrainings,
			},
		],
	},

	// Performance Review
	{
		path: '/hrperformancereviews',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrperformancereviews/', text: 'Performance Review' }] },
		children: [
			{
				path: '/hrperformancereviews/',
				name: 'hrperformancereviews-index',
				meta: { title: 'Performance Review' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrperformancereview', next) },
				component: HrPerformanceReviews,
			},
		],
	},

	// Onboarding
	{
		path: '/hronboardings',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hronboardings/', text: 'Onboarding' }] },
		children: [
			{
				path: '/hronboardings/',
				name: 'hronboardings-index',
				meta: { title: 'Onboarding' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hremployeeonboarding', next) },
				component: HrOnboardings,
			},
		],
	},

	// Report HR
	{
		path: '/hrreports',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrreports/', text: 'Report HR' }] },
		children: [
			{
				path: '/hrreports/',
				name: 'hrreports-index',
				meta: { title: 'Report HR' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrreport', next) },
				component: HrReports,
			},
		],
	},

	// Timesheet ticket
	{
		path: '/hrtickettimesheets',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrtickettimesheets/', text: 'Timesheet Ticket' }] },
		children: [
			{
				path: '/hrtickettimesheets/',
				name: 'hrtickettimesheets-index',
				meta: { title: 'Timesheet Ticket' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrtickettimesheet', next) },
				component: HrTicketTimesheets,
			},
		],
	},

	// Buste Paga
	{
		path: '/hrpayslips',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrpayslips/', text: 'Buste Paga' }] },
		children: [
			{
				path: '/hrpayslips/',
				name: 'hrpayslips-index',
				meta: { title: 'Buste Paga' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrpayslip', next) },
				component: HrPayslips,
			},
		],
	},

	// Timeline giornata
	{
		path: '/hrtimeline',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrtimeline/', text: 'Timeline Giornata' }] },
		children: [
			{
				path: '/hrtimeline/',
				name: 'hrtimeline-index',
				meta: { title: 'Timeline Giornata' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrtimeline', next) },
				component: HrTimelineMerge,
			},
		],
	},

	// Tipi Assenza
	{
		path: '/hrabsencetypes',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrabsencetypes/', text: 'Tipi Assenza' }] },
		children: [
			{
				path: '/hrabsencetypes/',
				name: 'hrabsencetypes-index',
				meta: { title: 'Tipi Assenza' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrabsencetype', next) },
				component: Crud,
				props: { modelDef: 'hrabsencetypes', actionIcon: 'mdi-shape-outline', title: 'Tipi Assenza', styleClass: 'mb-offset' }
			},
		],
	},
	{ path: '/hrabsencetypes/create', name: 'hrabsencetypes-create', beforeEnter: ifAuthenticatedOnline, component: Create, props: (route) => ({ modelDef: 'hrabsencetypes', defaultInput: route.params.defaultInput || null, redirect: route.params.redirect }) },
	{ path: '/hrabsencetypes/:id/edit', name: 'hrabsencetypes-edit', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hrabsencetypes', id: parseInt(route.params.id) }) },
	{ path: '/hrabsencetypes/:id', name: 'hrabsencetypes-show', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hrabsencetypes', id: parseInt(route.params.id) }) },

	// Ferie e Permessi (Absences)
	{
		path: '/hrabsences',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{ to: '/hrabsences/', text: 'Richieste' },
				{ to: '/hrabsences/inbox', text: 'Approvazioni' },
				{ to: '/hrabsences/calendar', text: 'Calendario Team' },
				{ to: '/hrabsences/balance', text: 'Residui' },
			],
		},
		children: [
			{
				path: '/hrabsences/',
				name: 'hrabsences-index',
				meta: { title: 'Ferie e Permessi' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrabsence', next) },
				component: HrAbsences,
			},
			{
				path: '/hrabsences/inbox',
				name: 'hrabsences-inbox',
				meta: { title: 'Approvazioni' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrabsence', next) },
				component: HrApprovalsInbox,
			},
			{
				path: '/hrabsences/calendar',
				name: 'hrabsences-calendar',
				meta: { title: 'Calendario Team' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrabsence', next) },
				component: HrTeamCalendar,
			},
			{
				path: '/hrabsences/balance',
				name: 'hrabsences-balance',
				meta: { title: 'Residui' },
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'hrabsence', next) },
				component: HrLeaveBalancePanel,
			},
		],
	},

	// === Voci virtuali del menu HR (raggruppano sotto-pagine via AppTabs) ===

	// Presenze (Cartellino + Timeline + Timbrature)
	{
		path: '/hrattendance',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{ to: '/hrattendance/cartellino', text: 'Cartellino', query: true },
				{ to: '/hrattendance/timeline', text: 'Timeline Giornata', query: true },
				{ to: '/hrattendance/timbrature', text: 'Timbrature', query: true },
			],
		},
		redirect: '/hrattendance/cartellino',
		children: [
			{ path: '/hrattendance/cartellino', name: 'hrattendance-cartellino', meta: { title: 'Cartellino' }, component: HrCartellino },
			{ path: '/hrattendance/timeline', name: 'hrattendance-timeline', meta: { title: 'Timeline Giornata' }, component: HrTimelineMerge },
			{ path: '/hrattendance/timbrature', name: 'hrattendance-timbrature', meta: { title: 'Timbrature' }, component: Crud, props: { modelDef: 'hrclocks', actionIcon: 'mdi-fingerprint', title: 'Timbrature', styleClass: 'mb-offset' } },
		],
	},

	// Retribuzione (Buste paga + Note spese + Timesheet ticket)
	{
		path: '/hrcompensation',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{ to: '/hrcompensation/payslips', text: 'Buste Paga' },
				{ to: '/hrcompensation/expenses', text: 'Note Spese' },
				{ to: '/hrcompensation/timesheets', text: 'Timesheet Ticket', model: 'trouble' },
			],
		},
		redirect: '/hrcompensation/payslips',
		children: [
			{ path: '/hrcompensation/payslips', name: 'hrcompensation-payslips', meta: { title: 'Buste Paga' }, component: HrPayslips },
			{ path: '/hrcompensation/expenses', name: 'hrcompensation-expenses', meta: { title: 'Note Spese' }, component: HrExpenses },
			{ path: '/hrcompensation/timesheets', name: 'hrcompensation-timesheets', meta: { title: 'Timesheet Ticket' }, component: HrTicketTimesheets },
		],
	},

	// Talent (Formazione + Performance + Onboarding)
	{
		path: '/hrtalent',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{ to: '/hrtalent/trainings', text: 'Formazione' },
				{ to: '/hrtalent/reviews', text: 'Performance Review' },
				{ to: '/hrtalent/onboarding', text: 'Onboarding' },
			],
		},
		redirect: '/hrtalent/trainings',
		children: [
			{ path: '/hrtalent/trainings', name: 'hrtalent-trainings', meta: { title: 'Formazione' }, component: HrTrainings },
			{ path: '/hrtalent/reviews', name: 'hrtalent-reviews', meta: { title: 'Performance Review' }, component: HrPerformanceReviews },
			{ path: '/hrtalent/onboarding', name: 'hrtalent-onboarding', meta: { title: 'Onboarding' }, component: HrOnboardings },
		],
	},

	// Impostazioni HR (config: reparti, mansioni, competenze, luoghi, dispositivi, turni, tipi assenza, onboarding templates)
	{
		path: '/hrsettings',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{ to: '/hrsettings/departments', text: 'Reparti' },
				{ to: '/hrsettings/job-titles', text: 'Mansioni' },
				{ to: '/hrsettings/skills', text: 'Competenze' },
				{ to: '/hrsettings/workplaces', text: 'Luoghi di Lavoro' },
				{ to: '/hrsettings/clock-devices', text: 'Dispositivi NFC/QR' },
				{ to: '/hrsettings/shifts', text: 'Turni' },
				{ to: '/hrsettings/absence-types', text: 'Tipi Assenza' },
				{ to: '/hrsettings/onboarding-templates', text: 'Template Onb./Offb.' },
				{ to: '/hrsettings/imports', text: 'Import dati' },
			],
		},
		redirect: '/hrsettings/departments',
		children: [
			{ path: '/hrsettings/departments', name: 'hrsettings-departments', meta: { title: 'Reparti' }, component: Crud, props: { modelDef: 'hrdepartments', actionIcon: 'mdi-domain', title: 'Reparti', styleClass: 'mb-offset', redirect: { modelDef: 'hrsettings-departments' } } },
			{ path: '/hrsettings/job-titles', name: 'hrsettings-jobtitles', meta: { title: 'Mansioni' }, component: Crud, props: { modelDef: 'hrjobtitles', actionIcon: 'mdi-briefcase-outline', title: 'Mansioni', styleClass: 'mb-offset', redirect: { modelDef: 'hrsettings-jobtitles' } } },
			{ path: '/hrsettings/skills', name: 'hrsettings-skills', meta: { title: 'Competenze' }, component: Crud, props: { modelDef: 'hrskills', actionIcon: 'mdi-star-circle-outline', title: 'Competenze', styleClass: 'mb-offset', redirect: { modelDef: 'hrsettings-skills' } } },
			{ path: '/hrsettings/workplaces', name: 'hrsettings-workplaces', meta: { title: 'Luoghi di Lavoro' }, component: Crud, props: { modelDef: 'hrworkplaces', actionIcon: 'mdi-map-marker', title: 'Luoghi di Lavoro', styleClass: 'mb-offset', redirect: { modelDef: 'hrsettings-workplaces' } } },
			{ path: '/hrsettings/clock-devices', name: 'hrsettings-clockdevices', meta: { title: 'Dispositivi NFC/QR' }, component: Crud, props: { modelDef: 'hrclockdevices', actionIcon: 'mdi-qrcode', title: 'Dispositivi NFC/QR', styleClass: 'mb-offset', redirect: { modelDef: 'hrsettings-clockdevices' } } },
			{ path: '/hrsettings/shifts', name: 'hrsettings-shifts', meta: { title: 'Turni' }, component: Crud, props: { modelDef: 'hrshifttemplates', actionIcon: 'mdi-calendar-clock', title: 'Turni', styleClass: 'mb-offset', redirect: { modelDef: 'hrsettings-shifts' } } },
			{ path: '/hrsettings/absence-types', name: 'hrsettings-absencetypes', meta: { title: 'Tipi Assenza' }, component: Crud, props: { modelDef: 'hrabsencetypes', actionIcon: 'mdi-tag-multiple', title: 'Tipi Assenza', styleClass: 'mb-offset', redirect: { modelDef: 'hrsettings-absencetypes' } } },
			{ path: '/hrsettings/onboarding-templates', name: 'hrsettings-onboardingtemplates', meta: { title: 'Template Onboarding/Offboarding' }, component: Crud, props: { modelDef: 'hronboardingtemplates', actionIcon: 'mdi-clipboard-text', title: 'Template Onboarding/Offboarding', styleClass: 'mb-offset', redirect: { modelDef: 'hrsettings-onboardingtemplates' } } },
			{ path: '/hrsettings/imports', name: 'hrsettings-imports', meta: { title: 'Import dati HR' }, component: HrImports },
		],
	},

	// Standalone path per il wizard (utile per linking diretto)
	{
		path: '/hrimports',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrimports/', text: 'Import Dati HR' }] },
		children: [
			{
				path: '/hrimports/',
				name: 'hrimports-index',
				meta: { title: 'Import Dati HR' },
				component: HrImports,
			},
		],
	},

	// Bacheca avvisi (admin CRUD).
	{
		path: '/hrannouncements',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/hrannouncements/', text: 'Bacheca avvisi' }] },
		children: [
			{
				path: '/hrannouncements/',
				name: 'hrannouncements-index',
				meta: { title: 'Bacheca avvisi' },
				component: Crud,
				props: { modelDef: 'hrannouncements', actionIcon: 'mdi-bullhorn', title: 'Bacheca avvisi', styleClass: 'mb-offset' },
			},
		],
	},
	{ path: '/hrannouncements/create', name: 'hrannouncements-create', beforeEnter: ifAuthenticatedOnline, component: Create, props: (route) => ({ modelDef: 'hrannouncements', defaultInput: route.params.defaultInput, redirect: route.params.redirect || { modelDef: 'hrannouncements-index' } }) },
	{ path: '/hrannouncements/:id/edit', name: 'hrannouncements-edit', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hrannouncements', id: parseInt(route.params.id), redirect: route.params.redirect || { modelDef: 'hrannouncements-index' } }) },
	{ path: '/hrannouncements/:id', name: 'hrannouncements-show', beforeEnter: ifAuthenticatedOnline, component: Edit, props: (route) => ({ modelDef: 'hrannouncements', id: parseInt(route.params.id) }) },

	// Self-service "I miei dati" — solo per utenti collegati a un dipendente HR.
	{
		path: '/hrme',
		name: 'hrme',
		meta: { title: 'I miei dati' },
		beforeEnter: ifHrEmployee,
		component: HrMe,
	},
]
